<template>
  <v-container grid-list-md text-xs-center>

    <v-card color="grey darken-3" class="white--text">
      <v-card-title>
        <v-text-field
          v-model="searchedAddon"
          name="input-10-2"
          label="Search for addons"
          append-icon="search"
          type="search"
        />
      </v-card-title>
    </v-card>

    <v-layout wrap v-if="searchedAddon === ''">
      <v-flex>
        <pluginList :loading="loading" class="elevation-1" header="Popular" icon="stars" :addons="popularAddons"/>
      </v-flex>

      <v-flex>
        <pluginList :loading="loading" class="elevation-1" header="Recents" icon="new_releases" :addons="newAddons"/>
      </v-flex>
<!--
      <v-flex>
        <pluginList :loading="loading" class="elevation-1" header="Hot this week" icon="whatshot" :addons="hotAddons"/>
      </v-flex>-->
    </v-layout>
    <v-layout wrap v-else>
      <v-flex>
        <pluginList :loading="loading" class="elevation-1" :header="`Results for ${searchedAddon}`" icon="search"
                    :addons="resultAddons"/>
      </v-flex>
    </v-layout>
  </v-container>

</template>

<script>
  import pluginList from './plugin-list/PluginList';
  import { addonsRef } from '../firebase';

  export default {
    name: 'home',
    computed: {
      popularAddons () {
        let popular = this.addons.slice(0);
        return popular.sort((a, b) => b[ 'dl_count' ] > a[ 'dl_count' ]).slice(0, 5);
      },
      newAddons () {
        return this.addons;
      },
      hotAddons () {
        return [];
      }
    },
    data () {
      return {
        loading: true,
        searchedAddon: '',
        resultAddons: [],
        searchOptions: {
          keys: [ 'id', 'name', 'description' ]
        }
      };
    },
    watch: {
      searchedAddon () {
        this.$search(this.searchedAddon, this.addons, this.searchOptions).then(results => {
          console.log('results', results);
          this.resultAddons = results;
        });
      }
    },
    firebase: {
      addons: addonsRef
    },
    components: {
      pluginList
    },
    mounted: function () {
      addonsRef.once('value', snapshot => {
        this.loading = false;
      });
    }
  };
</script>


<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Home.vue